import { Badge } from '@shopify/polaris';

export const StatusBadge = ({ type, status }) => {
  let badgeStatus = 'default';
  let badgeText = status;

  if (type === 'transfer') {
    switch (status) {
      case 'PENDING':
        badgeStatus = 'success';
        badgeText = 'Abierto';
        break;
      case 'IN_TRANSIT':
        badgeStatus = 'info';
        badgeText = 'En tránsito';
        break;
      case 'OPEN':
        badgeStatus = 'success';
        badgeText = 'Iniciado';
        break;
      case 'FINISHED':
        badgeStatus = 'warning';
        badgeText = 'En revisión';
        break;
      case 'CLOSED':
        badgeStatus = 'default';
        badgeText = 'Cerrado';
        break;
      case 'CANCELLED':
        badgeStatus = 'subdued';
        badgeText = 'Cancelado';
        break;
      default:
        badgeStatus = 'default';
        badgeText = status;
    }
  } else if (type === 'inventory') {
    switch (status) {
      case 'DRAFT':
        badgeStatus = 'warning';
        badgeText = 'Borrador';
        break;
      case 'SCHEDULED':
        badgeStatus = 'info';
        badgeText = 'Programado';
        break;
      case 'OPEN':
        badgeStatus = 'success';
        badgeText = 'Iniciado';
        break;
      case 'FINISHED':
        badgeStatus = 'warning';
        badgeText = 'En revisión';
        break;
      case 'CLOSED':
        badgeStatus = 'default';
        badgeText = 'Cerrado';
        break;
      case 'CANCELLED':
        badgeStatus = 'subdued';
        badgeText = 'Cancelado';
        break;
      default:
        badgeStatus = 'default';
        badgeText = status;
    }
  } else if (type === 'delivery') {
    switch (status) {
      case 'CLOSED':
        badgeStatus = 'default';
        badgeText = 'Cerrado';
        break;
      case 'OPEN':
      case 'PENDING':
        badgeStatus = 'info';
        badgeText = 'Abierto';
        break;
      case 'CANCELLED':
        badgeStatus = 'subdued';
        badgeText = 'Cancelado';
        break;
      default:
        badgeStatus = 'default';
        badgeText = status;
    }
  }

  return (
    <Badge size="small" status={badgeStatus}>
      {badgeText}
    </Badge>
  );
};
